export default (params) => ({
  trigger: {
    name: 'internal_icons.select_option',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      selection_type: {
        enum: [
          'pre_selected',
          'selected',
          'preferred',
        ],
      },
      option_name: {
        type: 'string',
      },
      attribute: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'vanessa',
          'clipboard_vanessa',
          'view_insurances_vanessa',
          'iris',
          'stock_information',
          'prixcilla',
          'product_attributes_in_pim',
          'product_roles',
          'store_product_tag',
          'logistic_information',
        ],
      },
    },
    event: {
      name: 'select_option',
    },
  },
});
